import { render, staticRenderFns } from "./TourRouter.vue?vue&type=template&id=3a232c96&"
import script from "./TourRouter.vue?vue&type=script&lang=js&"
export * from "./TourRouter.vue?vue&type=script&lang=js&"
import style0 from "./TourRouter.vue?vue&type=style&index=0&id=3a232c96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports